import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {CheckboxModule} from 'primeng/checkbox';
import {InputSwitchModule} from 'primeng/inputswitch';
import {TableModule} from 'primeng/table';
import {MessageService} from 'primeng/api';
import {AuthenticationModule} from '../authenticationModule/authentication.module';
import {CopyClipboardDirective} from './directives/copy-clipboard.directive';
import {NoDblClickDirective} from './directives/no-dbl-click.directive';

@NgModule({
  declarations: [
    NoDblClickDirective,
    CopyClipboardDirective
  ],
  imports: [
    CommonModule,
    AuthenticationModule,
    FormsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    DialogModule,
    ToastModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    InputSwitchModule,
    TableModule,
  ],
  providers: [
    MessageService,
  ],
  exports: [
    CommonModule,
    AuthenticationModule,
    FormsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    DialogModule,
    ToastModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    InputSwitchModule,
    TableModule,
    CopyClipboardDirective,
    NoDblClickDirective,
  ]
})
export class AppSharedModule {
}
